<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="现存量表"
      :page="page"
      :show-query="true"
      :queryParamsAppend="params"
      v-if="trendShow"
      :temp-params="tempParams"
      urlHash="business/stock/currentstock"
      :get-data-func="getDataFunc" 
      :summary-method="summaryFunc" 
      :show-summary="summaryShow"
    >  
    <!-- :get-data-func="api.currentStockRpt" -->
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template> 
      <template slot="query">
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

   
  </div>
</template>
<script>

  
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
export default {
  mixins: [listMixin],
  components: { list,  },
  data() {
    return {
      api: require('@/api/stock/stReport').default,
      trendShow: true,
      tableData: [],
      ProductName: "",
      tempParams: {

      },
      params: {
        ItemValue: null 
      },
      summaryShow: false,
      total: null
    };
  },
  activated(){
    this.getRouterInfo();
  },
  methods: {
    getDataFunc(params) {
      console.log("getDataFunc", params);
      return new Promise((resolve, reject) => {
        this.api.currentStockRpt(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.currentStockRptTotal(params).then(res => {
              console.log("total", res)
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    /** 千位符加两位小数 */
    summaryFunc(param) {
      console.log("summaryFunc", param.columns)
      const { columns, data } = param;
      var fields = ["BaseQuantity", "SubQuantity",'Amount','AvailableBaseQuantity','AvailableSubQuantity','PreEntryBaseQuantity','PreEntrySubQuantity','PreReleaseBaseQuantity','PreReleaseSubQuantity']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.currentStockRptExport(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    getRouterInfo(){
      if(this.$router.history.current.params){
        let params = this.$router.history.current.params
        console.log('this.$router.history.current.params', this.$router.history.current.params)
        this.tempParams.ProductName= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: params.ProductName
        };
        // this.tempParams.SourceType= {
        //   paramValueType: 'resetParamValue',
        //   isReset: true,
        //   value: this.$router.history.current.params.SourceType
        // };
        this.$refs.list.getData()
        this.params={}
      }
    }
    
   
  }
};
</script>
